import React from 'react'
import PropTypes from 'prop-types'
import SideNavigationContextProvider from './utils/context/sideNavigationContext'
import { ContactUsCollapseContexProvider } from './utils/context/ContactUsCollapseContext'
import GatedContentHandler from './utils/GatedContentHandler'
import HistoryTracker from './utils/history-tracker'
import { ShowAllProvider } from './utils/context/ShowAllContext'

const WrapPageElement = ({ element, props = {} }) => {
  const location = props.location
  const safeLocation = location || EMPTY_LOCATION

  return (
    <ShowAllProvider search={safeLocation.search}>
      <GatedContentHandler location={safeLocation}>
        <HistoryTracker />
        <SideNavigationContextProvider>
          <ContactUsCollapseContexProvider>
            {element}
          </ContactUsCollapseContexProvider>
        </SideNavigationContextProvider>
      </GatedContentHandler>
    </ShowAllProvider>
  )
}

WrapPageElement.propTypes = {
  element: PropTypes.node.isRequired,
  props: PropTypes.any
}

export default WrapPageElement
const EMPTY_LOCATION = { pathname: '', search: '', hash: '' }
